import { useEffect, Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Conditions from "@/components/Conditions";
import Approach from "@/components/Approach";
import Bio from "@/components/Bio";
import Benefits from "@/components/Benefits";
import Reviews from "@/components/Reviews";
import InstagramBand from "@/components/InstagramBand";
import SecondOpinion from "@/components/SecondOpinion";
import Faq from "@/components/Faq";
import Booking from "@/components/Booking";
import Footer from "@/components/Footer";
import GuideSection from "@/components/GuideSection";
import CallNow from "@/components/CallNow";
import AdminPanel from "@/components/AdminPanel";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="min-h-screen bg-ink flex items-center justify-center text-silver">
          Ops, qualcosa è andato storto. Ricarica la pagina.
        </div>
      );
    }
    return this.props.children;
  }
}

const Home = () => (
  <>
    <Nav />
    <main>
      <Hero />
      <Marquee />
      <Conditions />
      <Approach />
      <Bio />
      <Benefits />
      <Reviews />
      <InstagramBand />
      <SecondOpinion />
      <Faq />
      <GuideSection />
      <Booking />
    </main>
    <Footer />
    <CallNow />
  </>
);

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf = 0;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pannello" element={<AdminPanel />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Toaster position="top-center" richColors theme="dark" />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
